import type { EpilotTheme, Theme } from '@epilot/journey-elements'
import { BodyText, createStyles, makeStyles } from '@epilot/journey-elements'
import {
  type PriceItem,
  getLineDiscountDetails
} from '@epilot/journey-logic-commons'
import type { TFunction } from 'i18next'
import { useMemo } from 'react'

type CartItemDetailsLineDiscountProps = {
  item: PriceItem
  t: TFunction
  showTrailingDecimalZeros?: boolean
}

export const CartItemDetailsLineDiscount = ({
  item,
  t,
  showTrailingDecimalZeros
}: CartItemDetailsLineDiscountProps) => {
  const classes = useCartItemStyles()

  const { discountAmountToDisplay, beforeDiscountAmountTotalToDisplay } =
    useMemo(
      () => getLineDiscountDetails(item, t, showTrailingDecimalZeros),
      [item, showTrailingDecimalZeros, t]
    )

  return (
    <div className={classes.discountInnerContainer}>
      {beforeDiscountAmountTotalToDisplay !== undefined && (
        <BodyText
          className={classes.priceBeforeDiscount}
          color="textSecondary"
          display="block"
        >
          {beforeDiscountAmountTotalToDisplay}
        </BodyText>
      )}
      {discountAmountToDisplay !== undefined && (
        <BodyText
          className={classes.discount}
          color="textSecondary"
          display="block"
        >
          -{discountAmountToDisplay}
        </BodyText>
      )}
    </div>
  )
}

const useCartItemStyles = makeStyles<Theme & EpilotTheme>((theme) =>
  createStyles({
    discountInnerContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    priceBeforeDiscount: {
      textDecoration: 'line-through',
      opacity: 0.5,
      fontWeight: theme.typography.fontWeightBold as never
    },
    discount: {
      color: `var(--concorde-coupon-discount-color, ${theme.palette.error.main})`,
      fontWeight: theme.typography.fontWeightBold as never
    }
  })
)
